<template>
    <client-page>

        <sub-visual
        sh="Machining Products"
        tabActive="Metal"
        bg="/images/sub/visual/sv2.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    Metal
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/products/metal/metal-top-img.png"
            className="h-lg-300px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-84">
                    Various precision metal processing products used in the semiconductor industry
                </h3>
                <p class="min-w-80px min-w-lg-120px text-center color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Representative Material
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24">
                    SUS304, SUS316, Al5083, Al6061 etc..
                </p>
                <p class="min-w-80px min-w-lg-120px text-center color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Representative Product
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51">
                    Retainer Ring, Metal Shank for Wafer Back Grinding Wheel, Precision Parts for Semiconductors, etc..
                </p>
            </sub-bg-image>

        </section>

        <section v-if="boards" class="sub-section">
            <v-container>

                <slide-primary>
                    <div v-for="board in boards" :key="board._id" class="swiper-slide">
                        <div class="pb-16 pb-lg-30 border-bottom">
                            <div class="thum-wrap">
                                <div class="thum" :style="`background-image: url(${board.thumb})`"></div>
                            </div>
                        </div>
                    </div>
                </slide-primary>

            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <inquiry
                src="/images/sub/distributor/dupont/dupont-img1.png"
                name="Yoo Dong, Jang"
                tel="+82-31-765-2268"
                mail="ydjang@ist-co.kr"
                fax="82-31-765-2389">
                </inquiry>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import api from "@/api"
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import SlidePrimary from "@/components/client/en/sub/sub-slide-primary.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubBgImage,
        SlidePrimary,
        Inquiry,
    },
    data() {
        return {
            boards: null
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({
                params: { code: "metal" }
            })
            this.boards = boards;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>